<script>
  import Wrapper from '../components/Wrapper.svelte'
  import Apps from '../components/Home/Apps.svelte'
  import Support from '../components/Home/Support.svelte'
  import OperationSupport from '../components/Home/OperationSupport.svelte'
  import { userStore, is } from '../store'

</script>

<div class="bg-transparent relative w-full flex-grow box-border">
  <Wrapper>
    <div class="flex flex-col justify-center items-start text-white pt-10"
         style="height: 300px; margin-bottom: 90px;">
      <div class="font-light" style="font-size: 2.615385rem">Welcome to My FlexLink</div>
      <div class="font-light pt-6" style="font-size: 1.925rem">How can we help you today?</div>
    </div>
  </Wrapper>

  <Apps />

  <Support />

  {#if is($userStore.roles, 'internal')}
    <div class="mt-12">
      <OperationSupport />
    </div>
  {/if}

  <!--
  <div class="sm:mx-10 md:mx-12 mx-16">

    <div class="flex flex-wrap justify-center">
      {#each homeBoxes as box}
        <a href={'/#' + box.ref}><BoxCard {...box} /></a>
      {/each}
    </div>

    {#each searchResult as item}
      <div class="text-left mx-3 my-3 bg-white px-5 py-4 leading-loose">
        <SeachListItem {item} />
      </div>
    {/each}
  </div>
  -->
</div>

<style>
    #search-input {
        border: 1px #e0e0e0 solid;
    }

    #search-input:focus {
        border: 1px #222222 solid;
    }

    .search-label {
        width: 18px;
        height: 18px;
        top: 50%;
        margin-top: -9px;
    }
</style>
